<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (instrumentType()) {
  <statistics-trade-ticker
    [instrumentTypeOnly]="instrumentType()"
    [trades]="statisticsFacade.tradeTicker$ | async"
    [filter]="statisticsFacade.tradeTickerFilter$ | async"
    [loading]="statisticsFacade.tradeTickerLoading$ | async"
    (filterChange)="statisticsFacade.toggleTradeTickerFilter($event)"
  />
}
